import { useEffect, useState } from 'react';
import { trackEvent } from '../../lib/tracking';
import { Button } from '../common/button';
import { DEFAULT_VALUE, Slider } from '../slider/slider';

export const WineRating = ({
  wine,
  minLabel = null,
  maxLabel = null,
  onCall2ActionClick = null,
  call2ActionLabel = '',
  value,
  onRate,
}) => {
  const useCall2Action = call2ActionLabel && onCall2ActionClick;

  const [rating, setRating] = useState(DEFAULT_VALUE);

  useEffect(() => {
    if (value != rating) {
      setRating(value);
    }
  }, []);

  const handleOnRate = (sku, value) => {
    trackEvent({
      category: 'rate',
      action: sku,
      label: `${value}`,
    });
    onRate({ [sku]: value });
  };

  const onChange = (value) => {
    if (!useCall2Action) {
      handleOnRate(wine.defaultVariant.sku, value);
    }
    setRating(value);
  };

  const onClick = () => {
    handleOnRate(wine.defaultVariant.sku, rating);
    onCall2ActionClick(rating);
  };

  return (
    <>
      <Slider
        onChange={onChange}
        initValue={rating}
        minLabel={minLabel}
        maxLabel={maxLabel}
      />
      {useCall2Action && (
        <Button className='mt-8' onClick={onClick} filled={true}>
          {call2ActionLabel}
        </Button>
      )}
    </>
  );
};
